import React from 'react'

import './Loader.scss'

export default ({ white, ...props }) => (
  <div {...props} className={`loader ${white ? 'loader--white' : ''}`}/>
)
